import { render, staticRenderFns } from "./GraphDetail21.vue?vue&type=template&id=796b11d2&scoped=true"
import script from "./GraphDetail21.vue?vue&type=script&lang=js"
export * from "./GraphDetail21.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796b11d2",
  null
  
)

export default component.exports